/**
 * Calculate a MAC-based serial number from a device MAC address.
 *
 * Takes the last 3 octets of the MAC, interprets them as a hex number, and
 * renders that as a zero-padded 8-digit decimal string.
 * e.g. "B8:27:EB:F2:AC:53" -> "F2AC53" (hex) -> 15903827 -> "15903827"
 *
 * Returns an empty string when the MAC is missing or "N/A".
 */
export const calculateMacBasedSerial = (macAddress: string | undefined): string => {
  if (!macAddress || macAddress === 'N/A') return '';
  const cleanMac = macAddress.replace(/[:-]/g, '').toLowerCase();
  const last6Chars = cleanMac.slice(-6);
  const decimal = parseInt(last6Chars, 16);
  return decimal.toString().padStart(8, '0');
};
